<template>
  <v-container fluid>
    <material-card
      heading="공지사항 관리"
      icon-small
      icon="mdi-comment-alert-outline"
      title="공지사항 관리"
      color="primary"
    >
      <v-form v-model="isFormValid">
        <v-row
          class="mx-5"
        >
          <v-col
            cols="12"
            xl="2"
          >
            <v-textarea
              v-model="notice.contents"
              color="primary"
              label="공지사항"
              outlined
              dense
            />
            <div style="float: right;">
              <v-btn
                color="primary"
                @click="saveNotice"
              >
                저장
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </material-card>
  </v-container>
</template>
<script>
  import { snackbarOpen } from '@/util/helpers'

  export default {
    data: () => ({
      isFormValid: false,
      loading: false,
      notice: {
        _id: null,
        contents: '',
      },
    }),

    created () {
      this.getNotice()
    },

    mounted () {

    },

    methods: {
      async getNotice () {
        await this.$http.post('/api/v1/notice').then(response => {
          // console.log('response.data :: ' + JSON.stringify(response.data))
          if (response.data !== null) {
            this.notice._id = response.data[0]._id
            this.notice.contents = response.data[0].contents
          }
        }).catch(err => {
          console.log(err)
        })
      },
      async saveNotice () {
        if (this.notice._id !== null) {
          // console.log('saveNotice PUT START !!')
          await this.$http.put('/api/v1/notice', this.notice).then(response => {
            // console.log('saveNotice PUT success !!')
            snackbarOpen('success', '공지사항이 저장되었습니다.', 'success')
          }).catch(error => {
            console.log(error)
          })
        } else {
          // console.log('saveNotice POST START !!')
          await this.$http.post('/api/v1/notice', this.notice).then(response => {
            // console.log('saveNotice POST success !!')
            snackbarOpen('success', '공지사항이 저장되었습니다.', 'success')
          }).catch(error => {
            console.log(error)
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
